import {DisableDuplicatePipe} from "../components/dynamic-forms-components/pipes/disable-duplicate.pipe";
import {OptionsObservablePipe} from "./options-observable.pipe";
import {SearchPipe} from "./search.pipe";
import {IsBase64Pipe} from "./is-base64.pipe";
import {ReplacePipe} from "./replace.pipe";
import {SafeHtmlPipe} from "./safe-html.pipe";
import {TimeSincePipe} from "./time-since.pipe";
import {WithoutPipe} from "./without.pipe";
import {TruncatePipe} from "./truncate.pipe";
import {DynamicPipe} from "./dynamic.pipe";
import {RemoveUnderscorePipe} from "./remove-underscore.pipe";
import {EllipsisPipe} from "./ellipsis.pipe";
import {NumberPipePipe} from "./number.pipe";
import {ValueExistsPipe} from "./value-exists.pipe";
import {SortByDatePipe} from "./sort-by-date.pipe";
import {SortByPipe} from "./sort.pipe";
import {MustHavePipe} from "./must-have.pipe";
import {FilterBooleanPipe, FilterPipe} from "./filter.pipe";
import {ShortNumberPipe} from "./short-number.pipe";
import {WithLoadingNoObsCheckPipe, WithLoadingPipe} from "./with-loading.pipe";
import {ShowButtonPipe} from "./show-button.pipe";
import {ShowOtherButtonsPipe} from "./show-other-buttons.pipe";
import {ValueCheckerPipe} from "./value-checker.pipe";
import {ConcatPipe} from "./concat.pipe";
import {ObservablePipe} from "./observable.pipe";
import {CamelCaseSeperatorPipe} from "./camel-case-seperator.pipe";
import {StripHtmlTagsPipe} from "./strip-html-tags.pipe";

export const ImportExportPipes = [
  SearchPipe,
  IsBase64Pipe,
  ReplacePipe,
  SafeHtmlPipe,
  TimeSincePipe,
  WithoutPipe,
  TruncatePipe,
  DynamicPipe,
  RemoveUnderscorePipe,
  EllipsisPipe,
  OptionsObservablePipe,
  DisableDuplicatePipe,
  FilterBooleanPipe,
  FilterPipe,
  MustHavePipe,
  SortByPipe,
  SortByDatePipe,
  ValueExistsPipe,
  NumberPipePipe,
  ShortNumberPipe,
  WithLoadingPipe,
  WithLoadingNoObsCheckPipe,
  ShowButtonPipe,
  ShowOtherButtonsPipe,
  ValueCheckerPipe,
  ConcatPipe,
  ObservablePipe,
  CamelCaseSeperatorPipe,
  StripHtmlTagsPipe
]
